import { render, staticRenderFns } from "./simple_form_item.vue?vue&type=template&id=9de3bf4e&scoped=true&"
import script from "./simple_form_item.vue?vue&type=script&lang=js&"
export * from "./simple_form_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de3bf4e",
  null
  
)

export default component.exports